import React from 'react';
import { useState, createContext } from "react";


import Chapter from './Chapter';
import './Content.scss';
import Nav from '../nav/Nav';

export const UserContext = createContext();
export const ButtonContext = createContext();

const Content = () => {
   
    const [displayMethods, setdisplayMethods] = useState({display: false, title: "", text: ""});
    const [activeId, setActiveId] = useState(null);

    return (
        <UserContext.Provider value={{displayMethods, setdisplayMethods}}>
            <ButtonContext.Provider value={{activeId, setActiveId}}>
                <div className="main-layout">
                    <Nav />
                    <Chapter />
                </div>
            </ButtonContext.Provider>
        </UserContext.Provider>
    );
}

export default Content